/**
 * Every Gateway path this module calls.
 */
export const ratePlanEndpoints = {
  list: '/v1/rate-plans',
  create: '/v1/rate-plans',
  options: '/v1/rate-plans/options',
  detail: (ratePlanId: string) => `/v1/rate-plans/${ratePlanId}`,
  update: (ratePlanId: string) => `/v1/rate-plans/${ratePlanId}`,
  delete: (ratePlanId: string) => `/v1/rate-plans/${ratePlanId}`,
} as const;
